import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiTwitter, FiInstagram, FiLinkedin, FiGithub, FiArrowUp } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer bg-gradient">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <div className="logo-layers">
                  <span className="layer l1"></span>
                  <span className="layer l2"></span>
                  <span className="layer l3"></span>
                </div>
                <div className="logo-dots">
                  <span className="dot d1"></span>
                  <span className="dot d2"></span>
                  <span className="dot d3"></span>
                </div>
              </div>
              <span className="footer-logo-text">Roolink</span>
            </div>
            <p className="footer-desc">{t('footer.desc')}</p>
            <div className="footer-socials">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter"><FiTwitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram"><FiInstagram /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn"><FiLinkedin /></a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="GitHub"><FiGithub /></a>
            </div>
          </div>

          <div className="footer-links-group">
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li><a href="#home">{t('nav.home')}</a></li>
              <li><a href="#services">{t('nav.services')}</a></li>
              <li><a href="#portfolio">{t('nav.portfolio')}</a></li>
              <li><a href="#about">{t('nav.about')}</a></li>
              <li><a href="#contact">{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h4>{t('footer.services')}</h4>
            <ul>
              <li><a href="#services">{t('services.webDev.title')}</a></li>
              <li><a href="#services">{t('services.androidDev.title')}</a></li>
              <li><a href="#services">{t('services.iosDev.title')}</a></li>
              <li><a href="#services">{t('services.hosting.title')}</a></li>
              <li><a href="#services">{t('services.ai.title')}</a></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h4>{t('footer.legal')}</h4>
            <ul>
              <li><a href="/privacy-policy">{t('footer.privacy')}</a></li>
              <li><a href="/terms">{t('footer.terms')}</a></li>
              <li><a href="/delete-account">{t('footer.deleteAccount')}</a></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h4>{t('footer.connect')}</h4>
            <ul>
              <li><a href="mailto:info@roolink.net">{t('contact.info.email')}</a></li>
              <li><a href="tel:+965">{t('contact.info.phone')}</a></li>
              <li><a href="#contact">{t('contact.info.address')}</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Roolink. {t('footer.rights')}</p>
          <p className="footer-craft">{t('footer.poweredBy')}</p>
        </div>
      </div>

      <motion.button
        className="scroll-top-btn"
        onClick={scrollToTop}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        aria-label="Scroll to top"
      >
        <FiArrowUp />
      </motion.button>
    </footer>
  );
};

export default Footer;
